import { isFlatVisualBuilderSku } from '../../utils/visualBuilderSku'
import { flowTypeUsage, overLimitFlowUuids } from './flowLimits'

// The layout stores the dotted integration identifier ('vis.register_shipment'); GraphQL serializes it
// as an enum name with the first '.' replaced by '_' (portal-backend integrationIdentifierType.js).
export const graphqlIdentifier = flowTypeId => flowTypeId?.replace('.', '_')

// Visual Builder flows are built one at a time in Visual Builder: implementing a vb integration creates no flows.
export const isVisualBuilderIntegration = integration => isFlatVisualBuilderSku(integration?.integration_type_id)

// A row's chosen flow type (GraphQL enum form) as the catalog flow type id; an identifier the catalog
// does not know is kept as is, so it still counts (with no limit).
const catalogFlowTypeId = (integrationType, identifier) =>
  (integrationType?.flows || []).find(flowType => graphqlIdentifier(flowType.id) === identifier)?.id || identifier

// The target implementation's existing flows, typed by the planned flow each was created from.
// A flow whose planned flow is no longer in the layout has no known type and is skipped.
const existingFlows = (integration, partnerUuid) => {
  const target = (integration.implementations || []).find(item => item.partner_uuid === partnerUuid)
  return (target?.flows || []).flatMap(flow => {
    const plannedFlow = (integration.flows || []).find(item => item.flow_uuid === flow.planned_flow_uuid)
    return plannedFlow?.flow_type_id ? [{ flow_uuid: flow.flow_uuid, flow_type_id: plannedFlow.flow_type_id }] : []
  })
}

// Flow limits for one review section, counted by each included row's chosen flow type. In add mode
// (`addToPartnerUuid`) the target implementation's existing flows come first, so the rows being added
// are the ones past a limit. `integration` is the layout's full integration (all planned flows);
// `plannedFlows` and `rows` are the reviewed ones, index-aligned. Warn-only: nothing here blocks.
export const reviewLimits = ({ integration, plannedFlows, rows, integrationType, addToPartnerUuid = null }) => {
  const reviewed = plannedFlows.flatMap((plannedFlow, index) => {
    const row = rows[index]
    if (row.excluded || !row.integration_identifier) return []
    return [{ flow_uuid: plannedFlow.flow_uuid, flow_type_id: catalogFlowTypeId(integrationType, row.integration_identifier) }]
  })
  const flows = [...(addToPartnerUuid ? existingFlows(integration, addToPartnerUuid) : []), ...reviewed]
  return {
    flows,
    usage: new Map(flowTypeUsage(flows, integrationType).map(item => [item.flowTypeId, item])),
    overLimit: overLimitFlowUuids(flows, integrationType)
  }
}
